<template>
  <card-component title="Caballos" :subtitle="subtitle" class="has-table has-mobile-sort-spaced">
    <div slot="headerRight" class="card-header-icon">
      <div class="columns">
        <div class="column">
          <horse-table-filter @filtered="applyFilter"/>
        </div>
      </div>
    </div>
    <b-table
      slot="content"
      :loading="isLoading"
      :per-page="perPage"
      :striped="isStriped"
      :hoverable="hoverable"
      :data="horses"
      :total="totalData"
      :current-page.sync="currentPage"
      paginated
      backend-pagination
    >
      <template slot-scope="props">
        <b-table-column label="Nombre" field="name" >
          <p><b>{{props.row.name}}</b></p>
        </b-table-column>
        <b-table-column label="Jinete" field="rider">
          <p>
            <link-to-detail type="rider" :resource-id="props.row.rider.id" v-if="props.row.rider"> {{`${props.row.rider.lastname} ${props.row.rider.name}`}} </link-to-detail>
            <b v-else>S/I</b>
          </p>
        </b-table-column>
        <b-table-column label="Nivel Actual" field="start_at" centered >
          <lesson-pdf-button :type="props.row.status" v-if="props.row.status && props.row.lesson" :lesson-id="props.row.lesson.id" :text="props.row.lesson.name"/>
          <lesson-pdf-button v-else-if="props.row.lesson" :lesson-id="props.row.lesson.id" :text="props.row.lesson.name"/>
          <b-tag type="is-light" v-else>S/I</b-tag>
        </b-table-column>
        <b-table-column label="Edad" field="age" centered>
          {{ props.row.age ? props.row.age.years + ' - ' + props.row.age.months : 'S/I' }}
        </b-table-column>
        <b-table-column label="Género" field="gender" centered>
          <b-icon v-if="props.row.gender && props.row.gender === 'M'" icon="gender-male" type="is-info"></b-icon>
          <b-icon v-else-if="props.row.gender && props.row.gender === 'F'" icon="gender-female" type="is-danger"></b-icon>
          <p v-else>S/I</p>
        </b-table-column>
        <b-table-column label="Estado" field="status" centered>
          <status-horse :status="props.row.active" />
        </b-table-column>
        <!-- <b-table-column label="Nota" field="gender" sortable></b-table-column>
        <b-table-column label="Ranking" field="gender" sortable></b-table-column> -->
        <b-table-column custom-key="actions" class="is-actions-cell">
          <div class="buttons is-right">
            <b-button type="is-success" size="is-small" @click="$emit('edit', props.row.id)">
              Editar
            </b-button>
            <router-link :to="{name:'horses.detail', params: {id: props.row.id}}" :class="['button is-small', 'is-primary']">
              Ver detalles
            </router-link>
          </div>
        </b-table-column>
      </template>
      <section class="section" slot="empty">
        <div class="content has-text-grey has-text-centered">
          <template v-if="isLoading">
            <p>
              <b-icon icon="dots-horizontal" size="is-large" />
            </p>
            <p>Cargando Caballos...</p>
          </template>
          <template v-else>
            <p>
              <b-icon icon="horseshoe" size="is-large" />
            </p>
            <p>No hay registros de Caballos&hellip;</p>
          </template>
        </div>
      </section>
    </b-table>
  </card-component>
</template>

<script>
import HorseService from '@/services/HorseService'
import LessonService from '@/services/LessonService'
import StatusHorse from '@/components/StatusHorse'
import LinkToDetail from '@/components/LinkToDetail'
import LessonPdfButton from '@/components/LessonPDFButton'
import CardComponent from '@/components/CardComponent'
import HorseTableFilter from './filters/HorseTableFilter'

export default {
  props: {
    reload: {
      type: Boolean,
      default: false
    }
  },
  components: {
    StatusHorse,
    LinkToDetail,
    LessonPdfButton,
    CardComponent,
    HorseTableFilter
  },
  data () {
    return {
      horses: [],
      paginated: true,
      perPage: 10,
      currentPage: 1,
      totalData: 0,
      isStriped: true,
      isNarrowed: false,
      hoverable: true,
      isFocusable: false,
      isLoading: false,
      hasMobileCards: true,
      filters: null
    }
  },
  methods: {
    applyFilter (data) {
      this.filters = data
      this.getHorses()
    },
    async getHorses () {
      let params = {
        'include[0]': 'rider',
        'include[1]': 'lesson',
        'horse_status_id': 1,
        'per_page': this.perPage,
        'page': this.currentPage,
        ...this.filters
      }
      this.isLoading = true
      let response = await HorseService.getHorses(params)
      this.horses = response.data.data
      this.totalData = response.data.meta.total
      let lessonsResponse = await LessonService.getLessons()
      let lessons = lessonsResponse.data.data
      this.extractTopRanking(lessons)
    },
    extractTopRanking (lessons) {
      this.horses.forEach(item => {
        if (item.lesson_status) {
          if (item.lesson_status === 'medium') {
            item['status'] = 'is-warning'
          } else if (item.lesson_status === 'high') {
            item['status'] = 'is-success'
          } else if (item.lesson_status === 'low') {
            item['status'] = 'is-danger'
          }
        }
      })
      this.$emit('update:reload', false)
      this.isLoading = false
    }
  },
  computed: {
    subtitle () {
      let dataLenght = this.totalData
      let plural = dataLenght === 1 ? '' : 's'
      return `${dataLenght} caballo${plural} registrado${plural}`
    }
  },
  watch: {
    currentPage (value) {
      this.getHorses()
    },
    reload (value) {
      if (value === true) {
        this.getHorses()
      }
    }
  }
}
</script>
